/* =====================================================
   ENHANCED PRODUCT SECTION v14 - JavaScript
   With Sticky Navigation Bar
   ===================================================== */

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initProductEnhanced();
  });

  function initProductEnhanced() {
    // Find all enhanced product sections
    var sections = document.querySelectorAll('[id^="ep13-"]');
    
    sections.forEach(function(section) {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      
      initSection(section);
    });
  }

  function initSection(section) {

    var productId = parseInt(section.dataset.productId) || 0;
    // Get section ID
    var sectionId = section.id.replace('ep13-', '');
    
    // Get variant data
    var variantsData = document.getElementById('ep13-variants-' + sectionId);
    var variants = variantsData ? JSON.parse(variantsData.textContent) : [];
    
    // Get money format
    var moneyFormatEl = document.getElementById('ep13-money-format-' + sectionId);
    var moneyFormat = moneyFormatEl ? moneyFormatEl.textContent.trim() : '€{{amount_with_comma_separator}}';
    
    // Get initial variant ID from form
    var form = section.querySelector('form[data-type="add-to-cart-form"]');
    var initialVariantInput = form ? form.querySelector('input[name="id"]') : null;
    var initialVariantId = initialVariantInput ? parseInt(initialVariantInput.value) : null;
    
    // Current state
    var currentVariant = variants.find(function(v) { return v.id === initialVariantId; }) || variants[0];
    var currentQuantity = 1;
    
    // Elements
    var thumbs = section.querySelectorAll('.ep13-thumb');
    var mainImgs = section.querySelectorAll('.ep13-img');
    var colorBtns = section.querySelectorAll('.ep13-color-btn');
    var qtyInput = section.querySelector('[data-ep13-qty]');
    var minusBtn = section.querySelector('[data-ep13-minus]');
    var plusBtn = section.querySelector('[data-ep13-plus]');
    var priceEl = section.querySelector('[data-ep13-price]');
    var atcText = section.querySelector('[data-ep13-atc-text]');
    var atcBtn = section.querySelector('.ep13-atc');
    var variantInput = form ? form.querySelector('input[name="id"]') : null;
    var stockEl = section.querySelector('[data-ep13-stock]');
    var stockText = section.querySelector('[data-ep13-stock-text]');
    
    // Sticky Navigation Elements
    var stickyNav = section.querySelector('[data-ep13-sticky-nav]');
    var stickyAtcBtn = section.querySelector('[data-ep13-sticky-atc]');
    var navLinks = section.querySelectorAll('[data-ep13-nav-link]');
    
    // Format money helper
    function formatMoney(cents) {
      if (typeof cents === 'string') {
        cents = parseInt(cents.replace('.', ''), 10);
      }
      if (isNaN(cents)) return '';
      
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.round(cents / 100).toString();
      var amountComma = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(/\.(\d{2})$/, ',$1');
      
      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
    
    // Update quantity and price
    function updateQuantityPrice() {
      var totalPrice = currentVariant.price * currentQuantity;
      if (priceEl) {
        priceEl.textContent = formatMoney(totalPrice);
      }
      if (atcText && currentVariant.available) {
        atcText.textContent = 'Add to Cart - ' + formatMoney(totalPrice);
      }
    }
    
    // Update variant
    function updateVariant(variant) {
      currentVariant = variant;
      
      // Update price with quantity
      var totalPrice = variant.price * currentQuantity;
      if (priceEl) {
        priceEl.textContent = formatMoney(totalPrice);
        priceEl.dataset.unitPrice = variant.price;
      }
      
      // Update Add to Cart button
      if (atcText && atcBtn) {
        if (variant.available) {
          atcText.textContent = 'Add to Cart - ' + formatMoney(totalPrice);
          atcBtn.disabled = false;
        } else {
          atcText.textContent = 'Sold Out';
          atcBtn.disabled = true;
        }
      }
      
      // Update hidden variant input
      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.disabled = !variant.available;
      }
      
      // Update sticky nav button
      if (stickyAtcBtn) {
        stickyAtcBtn.dataset.variantId = variant.id;
        var btnText = stickyAtcBtn.querySelector('.btn-text');
        if (btnText) {
          btnText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        }
        stickyAtcBtn.disabled = !variant.available;
      }
      
      // Stock update with correct color
      if (stockEl && stockText) {
        var qty = variant.inventory_quantity;
        var policy = variant.inventory_policy;
        var management = variant.inventory_management;
        
        // Remove all classes
        stockEl.classList.remove('low-stock', 'out-of-stock', 'in-stock');
        stockEl.removeAttribute('data-status');
        
        // Check stock status
        if (!variant.available) {
          stockEl.classList.add('out-of-stock');
          stockEl.setAttribute('data-status', 'out');
          stockText.textContent = 'OUT OF STOCK';
        } else if (management === 'shopify' && qty <= 0 && policy !== 'continue') {
          stockEl.classList.add('out-of-stock');
          stockEl.setAttribute('data-status', 'out');
          stockText.textContent = 'OUT OF STOCK';
        } else {
          var urgencyPool = [1, 2, 3, 4, 5];
          var urgencySeed = (productId + variant.id) % 5;
          var urgencyQty = urgencyPool[urgencySeed];
          stockEl.classList.add('low-stock');
          stockEl.setAttribute('data-status', 'low');
          stockText.textContent = 'ONLY ' + urgencyQty + ' LEFT AT THIS PRICE';
        }
      }
      
      // Update URL
      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
    
    // Image Thumbnails - Also update variant
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = parseInt(this.dataset.index);
        var variantId = this.dataset.variantId;
        
        // Update active thumbnail
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        
        // Update main image
        mainImgs.forEach(function(img, i) {
          img.classList.toggle('ep13-hidden', i !== index);
        });
        
        // If this thumbnail is linked to a variant, update variant
        if (variantId) {
          var variant = variants.find(function(v) { return v.id === parseInt(variantId); });
          if (variant) {
            currentVariant = variant;
            updateVariant(variant);
            syncOptionButtons(variant);
          }
        }
      });
    });

    // Get all option groups (color + other options) and build selected options array by position
    function getSelectedOptions() {
      var optionContainers = section.querySelectorAll('[data-option-position]');
      var maxPos = 0;
      optionContainers.forEach(function(container) {
        var p = parseInt(container.getAttribute('data-option-position'), 10);
        if (p > maxPos) maxPos = p;
      });
      var selected = [];
      for (var pos = 1; pos <= maxPos; pos++) {
        var container = section.querySelector('[data-option-position="' + pos + '"]');
        if (!container) continue;
        var val = null;
        if (container.classList.contains('ep13-colors')) {
          var colorActive = container.querySelector('.ep13-color-btn.active');
          if (colorActive) val = colorActive.dataset.color;
        } else {
          var optionActive = container.querySelector('.ep13-option-value-btn.active');
          if (optionActive) val = optionActive.dataset.optionValue;
        }
        if (val != null) selected[pos - 1] = val;
      }
      return selected;
    }

    // Find variant whose options array matches the selected options (by position)
    function findVariantByOptions(selectedOptions) {
      return variants.find(function(v) {
        if (!v.options || v.options.length !== selectedOptions.length) return false;
        for (var i = 0; i < selectedOptions.length; i++) {
          if (selectedOptions[i] == null) return false;
          if (String(v.options[i]).toLowerCase() !== String(selectedOptions[i]).toLowerCase()) return false;
        }
        return true;
      });
    }

    // Sync all option buttons (color + others) to match the given variant
    function syncOptionButtons(variant) {
      if (!variant || !variant.options) return;
      variant.options.forEach(function(value, index) {
        var pos = index + 1;
        var container = section.querySelector('[data-option-position="' + pos + '"]');
        if (!container) return;
        var valueStr = String(value).toLowerCase();
        if (container.classList.contains('ep13-colors')) {
          container.querySelectorAll('.ep13-color-btn').forEach(function(btn) {
            btn.classList.toggle('active', String(btn.dataset.color || '').toLowerCase() === valueStr);
          });
        } else {
          container.querySelectorAll('.ep13-option-value-btn').forEach(function(btn) {
            btn.classList.toggle('active', String(btn.dataset.optionValue || '').toLowerCase() === valueStr);
          });
        }
      });
    }

    // =====================================================
    // HIDE/SHOW OPTION BUTTONS BASED ON STOCK AVAILABILITY
    // =====================================================
    // Check if a variant has stock
    function variantHasStock(variant) {
      if (!variant) return false;
      // No inventory management = always available
      if (!variant.inventory_management || variant.inventory_management === '') return true;
      // Continue selling when out of stock
      if (variant.inventory_policy === 'continue') return true;
      // Has stock
      return variant.inventory_quantity > 0;
    }

    // Hide/show option buttons based on current selection context
    function updateOptionAvailability() {
  var optionContainers = section.querySelectorAll('[data-option-position]');
  
  // Sort containers by position to process them in order (1, 2, 3...)
  var sortedContainers = Array.prototype.slice.call(optionContainers).sort(function(a, b) {
    return parseInt(a.getAttribute('data-option-position')) - parseInt(b.getAttribute('data-option-position'));
  });

  sortedContainers.forEach(function(container) {
    var position = parseInt(container.getAttribute('data-option-position'), 10);
    var isColor = container.classList.contains('ep13-colors');
    var btns = isColor
      ? container.querySelectorAll('.ep13-color-btn')
      : container.querySelectorAll('.ep13-option-value-btn');

    // Get FRESH selected options after each position update
    var currentSelected = getSelectedOptions();

    // Step 1: Show/hide buttons based on upstream selections only
    btns.forEach(function(btn) {
      var testValue = isColor ? btn.dataset.color : btn.dataset.optionValue;

      // Build test using only UPSTREAM selected values (positions before this one)
      // This position and downstream = null (open/unconstrained)
      var testSelected = [];
      for (var i = 0; i < currentSelected.length; i++) {
        if (i < position - 1) {
          testSelected[i] = currentSelected[i]; // keep upstream
        } else if (i === position - 1) {
          testSelected[i] = testValue; // test this button's value
        } else {
          testSelected[i] = null; // downstream = don't constrain
        }
      }

      var hasStock = variants.some(function(v) {
        if (!v.options || v.options.length !== testSelected.length) return false;
        for (var i = 0; i < testSelected.length; i++) {
          if (testSelected[i] == null) continue;
          if (String(v.options[i]).toLowerCase() !== String(testSelected[i]).toLowerCase()) return false;
        }
        return variantHasStock(v);
      });

      btn.style.display = hasStock ? '' : 'none';
    });

    // Step 2: If active button in this group is now hidden, auto-select first visible
    var activeBtn = container.querySelector(
      isColor ? '.ep13-color-btn.active' : '.ep13-option-value-btn.active'
    );

    var activeBtnHidden = activeBtn && activeBtn.style.display === 'none';
    var noActiveBtn = !activeBtn;

    if (activeBtnHidden || noActiveBtn) {
      // Find first visible button
      var firstVisible = null;
      btns.forEach(function(btn) {
        if (!firstVisible && btn.style.display !== 'none') {
          firstVisible = btn;
        }
      });

      if (firstVisible) {
        // Deactivate all, activate first visible
        btns.forEach(function(b) { b.classList.remove('active'); });
        firstVisible.classList.add('active');
      }
    }
  });

  // Step 3: After all positions processed, find + update the variant
  var finalSelected = getSelectedOptions();
  var newVariant = findVariantByOptions(finalSelected);
  if (newVariant) {
    currentVariant = newVariant;
    updateVariant(newVariant);
    updateImagesForVariant(newVariant);
  }
}
    // =====================================================

    // Update main image and thumbs to variant's featured media
    function updateImagesForVariant(variant) {
      if (!variant || !variant.featured_media_id || !thumbs.length) return;
      thumbs.forEach(function(thumb, index) {
        var mediaId = parseInt(thumb.dataset.mediaId, 10);
        if (mediaId === variant.featured_media_id) {
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          mainImgs.forEach(function(img) { img.classList.add('ep13-hidden'); });
          if (mainImgs[index]) mainImgs[index].classList.remove('ep13-hidden');
        }
      });
    }

    // Color Swatches
    colorBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var container = this.closest('[data-option-position]');
        if (container) {
          container.querySelectorAll('.ep13-color-btn').forEach(function(b) { b.classList.remove('active'); });
          this.classList.add('active');
        }
        var selected = getSelectedOptions();
        var variant = findVariantByOptions(selected);
        if (variant) {
          currentVariant = variant;
          updateVariant(variant);
          syncOptionButtons(variant);
          updateImagesForVariant(variant);
        }
        updateOptionAvailability(); // ← Hide unavailable options after color change
      });
    });

    // Other variant option buttons (Version, Model, Size, Battery, etc.)
    var optionValueBtns = section.querySelectorAll('.ep13-option-value-btn');
    optionValueBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var container = this.closest('[data-option-position]');
        if (container) {
          container.querySelectorAll('.ep13-option-value-btn').forEach(function(b) { b.classList.remove('active'); });
          this.classList.add('active');
        }
        var selected = getSelectedOptions();
        var variant = findVariantByOptions(selected);
        if (variant) {
          currentVariant = variant;
          updateVariant(variant);
          syncOptionButtons(variant);
          updateImagesForVariant(variant);
        }
        updateOptionAvailability(); // ← Hide unavailable options after selection change
      });
    });
    
    // Quantity minus button
    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
          currentQuantity = val - 1;
          updateQuantityPrice();
        }
      });
    }
    
    // Quantity plus button
    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
        currentQuantity = val + 1;
        updateQuantityPrice();
      });
    }
    
    // Quantity input change
    if (qtyInput) {
      qtyInput.addEventListener('change', function() {
        var val = parseInt(this.value) || 1;
        if (val < 1) val = 1;
        this.value = val;
        currentQuantity = val;
        updateQuantityPrice();
      });
    }
    
    // ===== STICKY NAVIGATION BAR =====
    if (stickyNav) {
      var footer = document.querySelector('.footer') || document.querySelector('footer');
      var secondSection = document.querySelectorAll('#MainContent .shopify-section')[1];
      
      function updateStickyNav() {
        var scrollY = window.scrollY;
        var navHeight = stickyNav.offsetHeight;
        var sectionRect = section.getBoundingClientRect();
        var footerTop = footer ? footer.offsetTop : Infinity;
        
        var showNav = false;
        
        if (secondSection) {
          var secondRect = secondSection.getBoundingClientRect();
          showNav = secondRect.top < 0;
        } else {
          showNav = scrollY > 500;
        }
        
        var isNearFooter = window.innerHeight + scrollY - navHeight > footerTop;
        
        if (showNav && !isNearFooter) {
          stickyNav.classList.add('show');
        } else {
          stickyNav.classList.remove('show');
        }
        
        navLinks.forEach(function(link) {
          var targetId = link.dataset.ep13NavLink;
          var targetEl = null;
          
          if (targetId === 'overview') {
            targetEl = section;
          } else if (targetId === 'specifications') {
            targetEl = document.getElementById('product-specifications');
          }
          
          if (targetEl) {
            var rect = targetEl.getBoundingClientRect();
            if (rect.top <= 1 && rect.top > rect.height * -1) {
              link.classList.add('active');
            } else {
              link.classList.remove('active');
            }
          }
        });
      }
      
      document.addEventListener('scroll', updateStickyNav);
      
      navLinks.forEach(function(link) {
        link.addEventListener('click', function() {
          var targetId = this.dataset.ep13NavLink;
          var targetEl = null;
          
          if (targetId === 'overview') {
            targetEl = section;
          } else if (targetId === 'specifications') {
            targetEl = document.getElementById('product-specifications');
          }
          
          if (targetEl) {
            targetEl.scrollIntoView({ behavior: 'smooth' });
          }
        });
      });
      
      if (stickyAtcBtn) {
        stickyAtcBtn.addEventListener('click', function() {
          var variantId = this.dataset.variantId;
          var btn = this;
          
          if (!variantId || btn.disabled) return;
          
          btn.classList.add('loading');
          btn.disabled = true;
          
          var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: parseInt(variantId),
              quantity: qty
            })
          })
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Failed to add to cart');
            }
            return response.json();
          })
          .then(function(data) {
            window.location.href = '/cart';
          })
          .catch(function(error) {
            console.error('Add to cart error:', error);
            btn.classList.remove('loading');
            btn.disabled = false;
            
            var btnText = btn.querySelector('.btn-text');
            if (btnText) {
              var originalText = btnText.textContent;
              btnText.textContent = 'Error - Try Again';
              setTimeout(function() {
                btnText.textContent = originalText;
              }, 2000);
            }
          });
        });
      }
    }
    
    // ===== POPUP MODAL =====
    var modal = section.querySelector('[data-ep13-modal]');
    var popupBtns = section.querySelectorAll('[data-ep13-popup]');
    var closeBtn = section.querySelector('[data-ep13-modal-close]');
    var tabBtns = section.querySelectorAll('[data-ep13-tab]');
    var panels = section.querySelectorAll('[data-ep13-panel]');
    var panelImgs = section.querySelectorAll('[data-ep13-panel-img]');
    
    var sizeTabBtns = section.querySelectorAll('[data-ep13-size-tab]');
    var sizeTabContents = section.querySelectorAll('[data-ep13-size-content]');
    
    function openModal(tab) {
      if (modal) {
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
        switchTab(tab);
      }
    }
    
    function closeModal() {
      if (modal) {
        modal.classList.remove('open');
        document.body.style.overflow = '';
      }
    }
    
    function switchTab(tab) {
      tabBtns.forEach(function(b) { b.classList.remove('active'); });
      panels.forEach(function(p) { p.classList.remove('active'); });
      
      var activeTab = section.querySelector('[data-ep13-tab="' + tab + '"]');
      var activePanel = section.querySelector('[data-ep13-panel="' + tab + '"]');
      
      if (activeTab) activeTab.classList.add('active');
      if (activePanel) activePanel.classList.add('active');
      
      panelImgs.forEach(function(img) { img.style.display = 'none'; });
      var activeImg = section.querySelector('[data-ep13-panel-img="' + tab + '"]');
      if (activeImg) {
        activeImg.style.display = 'block';
      } else {
        var fallbackImg = section.querySelector('[data-ep13-panel-img="fallback"]');
        if (fallbackImg) fallbackImg.style.display = 'block';
      }
    }
    
    function switchSizeTab(tabId) {
      sizeTabBtns.forEach(function(btn) { btn.classList.remove('active'); });
      sizeTabContents.forEach(function(content) { content.classList.remove('active'); });
      
      var activeBtn = section.querySelector('[data-ep13-size-tab="' + tabId + '"]');
      var activeContent = section.querySelector('[data-ep13-size-content="' + tabId + '"]');
      
      if (activeBtn) activeBtn.classList.add('active');
      if (activeContent) activeContent.classList.add('active');
    }
    
    popupBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        openModal(this.dataset.ep13Popup);
      });
    });
    
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }
    
    if (modal) {
      modal.addEventListener('click', function(e) {
        if (e.target === modal) closeModal();
      });
    }
    
    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        switchTab(this.dataset.ep13Tab);
      });
    });
    
    sizeTabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        switchSizeTab(this.dataset.ep13SizeTab);
      });
    });
    
    // Escape key to close modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('open')) {
        closeModal();
      }
    });

    // ← Run on page load to hide any zero-stock options immediately
    updateOptionAvailability();
  }

  // Expose init function for dynamic loading
  window.initProductEnhanced = initProductEnhanced;

})();